import { render } from "./NovelCellRead.vue?vue&type=template&id=3d08d862&scoped=true&ts=true"
import script from "./NovelCellRead.vue?vue&type=script&lang=ts"
export * from "./NovelCellRead.vue?vue&type=script&lang=ts"

import "./NovelCellRead.vue?vue&type=style&index=0&id=3d08d862&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d08d862"]])

export default __exports__